/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HousewareSprayIcon16Solid = forwardRef('HousewareSprayIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M15.224.947a.5.5 0 1 0-.448-.894l-2.5 1.25a.5.5 0 1 0 .448.894l2.5-1.25Z" }),
        React.createElement("path", { d: "M4.5 1A1.5 1.5 0 0 0 3 2.5v2.41l8-1.333V2a1 1 0 0 0-1-1H4.5Z" }),
        React.createElement("path", { d: "M3 13V5.924l4-.667v1.566a1 1 0 0 0 .629.929l3.114 1.245A2 2 0 0 1 12 10.854V13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" }),
        React.createElement("path", { d: "M8 7V5.09l2-.333V7.75L8 7Z" }),
        React.createElement("path", { d: "M12.724 4.803a.5.5 0 1 0-.448.894l2.5 1.25a.5.5 0 1 0 .448-.894l-2.5-1.25Z" }),
        React.createElement("path", { d: "M12.5 3.5A.5.5 0 0 1 13 3h2.5a.5.5 0 0 1 0 1H13a.5.5 0 0 1-.5-.5Z" })));
});
